import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-49" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-50" data-mp="1nwmetz0a1iw7">
        <div className="mb-12 text-center" data-id="element-51" data-mp="2blf2l86qwkfq">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-52" data-mp="2bmgok7paurc8">
            Gut zu wissen
          </p>
          <h2 className="mt-4 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-53" data-mp="21vcb5cf9veji">
            Häufig gestellte Fragen
          </h2>
        </div>
        <div className="space-y-3" data-id="element-54" data-mp="26rj7cdhv9bo9">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-brand-line bg-brand-alt shadow-sm" data-id="element-55" data-mp="2zc1amzgr24pq" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-display text-lg font-bold text-brand-navy transition-colors duration-150 ease-out hover:bg-brand-main focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-56" data-mp="1rph33ezl5o4w">
                  <span data-id="element-57" data-mp="2oc2mj2w329xz">{faq.question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-58" data-mp="2jfvdh18e4ibt" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-59" data-mp="p2mazte9hx32" />}
                </button>
                <AnimatePresence initial={false} data-id="element-60" data-mp="2u36x5yeysm7e">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-61" data-mp="2z0ov6trg1h0m">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-62" data-mp="3hrpw3nc4jmmt">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}